import { combineReducers } from "redux";
import CommonReducer from "./CommonReducer";
import popup from "./popup";
import SystemSettingsReducer from "./SystemSettings";
import CommandsReducer from "./CommandsReducer";
import  ProductionReducer  from "./ProductionReducer";
const reducers = combineReducers({CommonReducer, popup, SystemSettingsReducer, CommandsReducer, ProductionReducer});
export default reducers;